import { FiltersModel } from '../filters';
import { DataModel, DataListModel } from '../data';
import { StateCountryModel } from './state-country.model';

export interface CityModel extends DataModel {
  external_id?: string;
  name: string;
  state?: StateCountryModel;
}

export interface CityListModel extends DataListModel {
  results: CityModel[];
}

export interface CityFilterModel extends FiltersModel {
  name?: string;
  state_id?: number;
}
